// IndividualReport.js
// Component for Individual Order Report

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import ReportCard from './ReportCard';
import ClientSelect from './ClientSelect';
import OrderSelect from './OrderSelect';
import DateInput from './DateInput';
import dateFormat from 'dateformat';

// Component Class
// Shows Individual Order Report Card
class IndividualReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      order: this.getFirstOrder(),
      clientId: this.getFirstClient(),
      delivery: dateFormat(new Date(), "dd/mm/yyyy"),
    }
  }

  // Checks if state is still valid after an update
  componentDidUpdate() {
    if (this.state.order === this.props.orders.current) return;
    for (var i = 0; i < this.props.orders.archive.length; i++) {
      var order = this.props.orders.archive[i];
      if (this.state.order === order)
        return;
    }

    this.setState({
      order: this.getFirstOrder(),
      clientId: this.getFirstClient(),
      delivery: dateFormat(new Date(), "dd/mm/yyyy"),
    });
  }

  // Returns the filename for the downloaded report
  getFilename = () => {
    var order = this.state.order;
    var date = order && order.dateClosed ? new Date(order.dateClosed) : new Date();
    var dateStr = dateFormat(date, "yyyy.mm.dd");
    var clientName = this.state.clientId ? this.props.clients.byId[this.state.clientId].name : "";
    clientName = clientName.replace(/\s/g,'_');
    clientName = clientName.replace('.','');

    return "Carlinhos_"+clientName+"_"+dateStr+".pdf";
  }

  // Returns the processed report object
  getReport = () => {
    return this.props.report.getOrderReport(this.state.clientId, [this.state.order], this.state.delivery);
  }

  // Sets the current order to generate reports for
  setOrder = (order) => {
    this.setState({order: order});
  }

  // Returns the first order for the given client
  getFirstOrder = (clientId) => {
    if (!clientId)
      clientId = this.getFirstClient();
    if (this.filterOrder(this.props.orders.current, clientId))
      return this.props.orders.current;
    for (var i = this.props.orders.archive.length - 1; i >= 0; i--) {
      var order = this.props.orders.archive[i];
      if (this.filterOrder(order, clientId))
        return order;
    }
    return null;
  }

  // Sets the target client
  setClient = (clientId) => {
    var newOrder = this.state.order;
    if (!newOrder || !this.filterOrder(newOrder, clientId))
      newOrder = this.getFirstOrder(clientId);
      
    this.setState({
      clientId: clientId,
      order: newOrder,
    });
  }

  // Returns the first client with orders
  getFirstClient = () => {
    for (var i = 0; i < this.props.clients.ids.length; i++) {
      var id = this.props.clients.ids[i];
      if (this.filterClient(id))
        return id;
    }
    return this.props.clients.ids[0];
  }

  // Returns whether the given client should show on list
  filterClient = (clientId) => {
    return this.hasOrders(clientId);
  }

  // Returns whether the given order from a given client should show on list
  filterOrder = (order, clientId) => {
    if (!clientId)
      clientId = this.state.clientId;
    return clientId && order.byClient[clientId];
  }

  // Returns whether the given client has any orders
  hasOrders = (clientId) => {
    if (!clientId)
      clientId = this.state.clientId;
    if (this.filterOrder(this.props.orders.current, clientId))
      return true;
    for (var i = 0; i < this.props.orders.archive.length; i++)
      if (this.filterOrder(this.props.orders.archive[i], clientId))
        return true;
    return false;
  }

  // Sets the target delivery date
  setDelivery = (date) => {
    this.setState({delivery: date !== "" ? date : null})
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Pedido Individual"
        description="Resumo de um único pedido de um cliente."
        getReport={this.getReport}
        getFilename={this.getFilename}
        disabled={!this.hasOrders()}
      >
        <center>
          <ClientSelect
            clients={this.props.clients}
            selected={this.state.clientId}
            setClient={this.setClient}
            filter={this.filterClient}
          />
          <br />
          <br />
          <OrderSelect
            orders={this.props.orders}
            selected={this.state.order}
            setOrder={this.setOrder}
            filter={this.filterOrder}
          />
          <br />
          <br />
          <DateInput
            setDate={this.setDelivery}
            date={this.state.delivery}
          />
        </center>
        <br />
      </ReportCard>
    );
  }
}

// Required Properties
IndividualReport.propTypes = {
  orders: PropTypes.object.isRequired,
  clients: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
}

// Exports
export default IndividualReport;


// WEBPACK FOOTER //
// ./src/components/ReportView/IndividualReport.js